<template>
  <div style="height: 100%;background-color: white">
    <el-row style="height: calc(100% - 15px);padding-top: 15px;margin: 0 15px">
      <el-col v-if="isAll" style="height: 100%" :span="4">
        <div style="height: 60px;">
          <el-input placeholder="请输入名字查询" v-model="searchKeyword" style="width: calc(100% - 100px)" @blur="blurSearch()"></el-input>
          <el-button icon="el-icon-search" type="primary" plain @click="getSearchTable1()">查询</el-button>
        </div>
        <div style="height: calc(100% - 60px)">
          <div style="max-height: calc(100% - 30px);overflow-y: auto;">
            <div class="card-person" v-for="item in oldPersonList" :key="item.id" @click="changeOldPerson(item)">
              <div class="top-name-person">&nbsp;&nbsp;<span v-if="$store.state.user.moduletag !== 2">{{ item.name }}</span><span v-else>{{item.person_name}}</span></div>
              <div class="bottom-phone-person">&nbsp;&nbsp;<span v-if="$store.state.user.moduletag !== 2">{{ item.phone }}</span><span v-else>{{getBedDesc(item)}}</span></div>
            </div>
<!--            <div v-else class="card-person" v-for="item in oldPersonList" :key="item.id" @click="changeOldPerson(item)">-->
<!--              <div class="top-name-person">&nbsp;&nbsp;{{ item.person_name }}</div>-->
<!--              <div class="bottom-phone-person">&nbsp;&nbsp;{{ getBedDesc(item) }}</div>-->
<!--            </div>-->
          </div>
          <div style="height: 30px;text-align: center">
            <el-pagination v-fixZoom :page-size="20" small layout="prev, pager, next" :total="totalCells" @current-change="handleCurrentChange"></el-pagination>
          </div>
        </div>
      </el-col>
      <el-col style="height: 100%" :span="col1">
        <div class="person-device" v-if="$store.state.user.moduletag !== 2">
          <service-object-alarm :serviceObj="serviceObj" ref="oldperson"></service-object-alarm>
        </div>
        <div v-else class="box-card">
          <div v-if=" serviceObj.oldperson === ''" style="height: 100px;text-align: center;font-size: 22px;line-height: 100px">请选择人员信息</div>
          <el-row v-else style="font-size: 18px;margin: 0 40px;padding-top: 20px">
<!--            <el-col :span="3">-->
<!--              <div v-if="serviceObj.oldperson.elderly_photo !== ''" class="bg-photo">-->
<!--                <img :src="serviceObj.oldperson.elderly_photo">-->
<!--              </div>-->
<!--              <div v-else class="bg-photo">-->
<!--                <img v-if="serviceObj.oldperson.gender === '2'" src="static/nv.png">-->
<!--                <img v-else src="static/nan.png">-->
<!--              </div>-->
<!--            </el-col>-->
            <el-col :span="24">
              <el-col :span="12" style="height: 40px">
                <span style="font-weight: bold">姓名：</span>
                <span> {{serviceObj.oldperson.person_name}}</span>
              </el-col>
              <el-col :span="12" style="height: 40px">
                <span style="font-weight: bold">性别：</span>
                <span> {{getSexDesc(serviceObj.oldperson.sex + '')}}</span>
              </el-col>
              <el-col :span="12" style="height: 40px">
                <span style="font-weight: bold">生日：</span>
                <span>{{getAgeDesc(serviceObj.oldperson.birthday)}}</span>
                (<span>{{serviceObj.oldperson.birthday}}</span>)
              </el-col>
              <el-col :span="12" style="height: 40px">
                <span style="font-weight: bold">身份证号：</span>
                <span> {{serviceObj.oldperson.idcard_num}}</span>
              </el-col>
            </el-col>
            <el-col :span="24" style="height: 40px">
              <span style="font-weight: bold">房间号：</span>
              <span> {{getBedDesc(serviceObj.oldperson)}}</span>
            </el-col>
          </el-row>
        </div>
        <div style="margin: 15px">
          <el-table size="mini" :data="homeDeviceTable" border style="width: 100%" highlight-current-row>
            <el-table-column
              type="index"
              label="序号"
              width="50"
              align="center">
            </el-table-column>
            <el-table-column
              label="设备编号"
              min-width="130"
              align="center">
              <template slot-scope="scope">
                <div v-if="scope.row.devicetype !== 700">
                  {{scope.row.deviceid}}
                </div>
                <div v-else>
                  <el-tooltip placement="top" effect="dark">
                    <div slot="content">
                      <span style="font-size: 14px">版本号：</span>
                      <span style="font-size: 14px">{{scope.row.ver}}</span><br>
                      <span style="font-size: 14px">雷达监测结果：</span>
                      <span style="font-size: 14px" v-if="scope.row.radarstaus === 'tx'">休息</span>
                      <span style="font-size: 14px" v-if="scope.row.radarstaus === 'out'">动作</span><br>
                      <span style="font-size: 14px">雷达监测时间：</span>
                      <span style="font-size: 14px">{{scope.row.radartime}}</span><br>
                    </div>
                    <div>
                      <img style="vertical-align: sub;width: 20px;height: 20px"
                           src="/static/tableIcon/lie.png"
                           v-if="scope.row.radarstaus === 'tx'">
                      <img style="vertical-align: sub;width: 20px;height: 20px"
                           src="/static/tableIcon/walk.png"
                           v-if="scope.row.radarstaus === 'out'">
                      <span>{{scope.row.deviceid}}</span>
                    </div>
                  </el-tooltip>
                </div>
              </template>
            </el-table-column>
            <el-table-column
              prop="last_online"
              label="最后在线时间"
              min-width="140"
              align="center">
            </el-table-column>
            <el-table-column
              prop="h_installlocation"
              label="安装位置"
              min-width="75"
              align="center">
            </el-table-column>
            <el-table-column align="center" label="操作" width="70">
              <template slot-scope="scope">
                <i v-if="scope.row.devicetype === 700"
                   style="cursor: pointer; font-size: 18px;color: blue"
                   title="视频通话"
                   class="el-icon-video-camera" @click="callVideo(scope.row)"></i>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-col>
      <el-col style="height: 100%" :span="col2">
        <zg-page ref="zgpage" @zgEnd="zgEnd"></zg-page>
      </el-col>
    </el-row>
  </div>
</template>

<script>

import {
  querybinddevicebyhome,
  queryfrequency,
  queryoldpersonpage,
  queryproject,
  searcholdperson
} from '../../api/serviceObject'
import {calldeicevideo, receivedeicevideo} from '../../api/zego'
import {queryoldpersonbypids, queryoldpersonbyimei} from '../../api/handlealarm'
import serviceObjectAlarm from '../handlealarm/childComponents/serviceObjectAlarm'
import zgPage from './childComponents/zgPage'
import {queryhomebedelderly} from '../../api/yanglaoyuan/homebed'
export default {
  name: 'videoZg',
  components: {serviceObjectAlarm, zgPage},
  data () {
    return {
      isAll: true,
      col1: 12,
      col2: 8,
      orgid: '',
      searchKeyword: '',
      pageSize: 20,
      currentPage: 1,
      totalCells: 0,
      oldPersonList: [],
      selectOldPersonObj: '',
      // 服务对象
      serviceObj: {
        projects: [],
        frequencys: [],
        oldperson: '',
        isCallBack: false
      },
      // 设备
      homeDeviceTable: [],
      watchesTable: [],
      zgObj: {
        token: '',
        AppID: 3654222617,
        server: 'wss://webliveroom3654222617-api-bak.imzego.com/ws',
        roomID: ''
      },
      roomID: '', // 接口请求回来的房间号
      // 接口参数
      sendObj: {
        deviceid: '',
        name: '',
        videotype: 'video',
        roomid: '',
        result: ''
      },
      isMyCall: false,
      isCallTimer: null
    }
  },
  created () {
    this.orgid = this.$store.state.user.orgid
    if (this.$store.state.user.moduletag !== 2) {
      this.getFrequency()
      this.getProjects()
      this.getOldPersonTable()
    } else {
      this.getHomebedElderlyData()
    }
    if (this.$route.query.id) {
      this.col1 = 14
      this.col2 = 10
      this.isAll = false
      this.getOldPersonOyId(this.$route.query.id)
    }
    if (this.$route.query.deviceid) {
      this.col1 = 14
      this.col2 = 10
      this.isAll = false
      if (this.store2.state.other.zgVideoObj !== '') {
        this.roomID = this.store2.state.other.zgVideoObj.roomid
        this.sendObj.deviceid = this.$route.query.deviceid
        this.sendObj.name = this.store2.state.other.zgVideoObj.name
        this.sendObj.roomid = this.store2.state.other.zgVideoObj.roomid
      }
      this.getOldPersonOyDid(this.$route.query.deviceid)
    }
    this.golobleObject.mattVideoCallPage = this.mqttResultZg
  },
  destroyed () {
    this.$store.commit('set_is_mqtt', false)
    this.store2.dispatch('other/update_zg_info', '')
  },
  methods: {
    getOldPersonOyId (id) {
      let data = { pids: [parseInt(id)] }
      queryoldpersonbypids(data).then(res => {
        if (res.data.persons.length > 0) {
          this.changeOldPerson(res.data.persons[0])
        }
      }).catch(() => {})
    },
    getOldPersonOyDid (deviceid) {
      let data = { imei: deviceid }
      this.sendObj.deviceid = deviceid
      queryoldpersonbyimei(data).then(res => {
        if (this.store2.state.other.zgVideoObj !== '') {
          this.sendZg(0) // 设备拨打进来接听
        }
        if (res.data.persons.length > 0) {
          if (this.$store.state.user.moduletag !== 2) {
            this.changeOldPerson(res.data.persons[0])
          } else {
            let obj = {
              id: res.data.persons[0].id,
              person_name: res.data.persons[0].name,
              birthday: res.data.persons[0].birthday,
              sex: res.data.persons[0].sex,
              idcard_num: res.data.persons[0].idcard_num,
              hid: res.data.persons[0].homeid
            }
            this.changeOldPerson1(obj)
          }
        }
      }).catch(() => {})
    },
    // 查询频率
    getFrequency () {
      let data = { orgid: this.orgid }
      queryfrequency(data).then(res => {
        this.serviceObj.frequencys = res.data.frequencys
      }).catch(() => {})
    },
    // 查询项目
    getProjects () {
      let data = { orgid: this.orgid }
      queryproject(data).then(res => {
        this.serviceObj.projects = res.data.projects
      }).catch(() => {})
    },
    // 分页表格
    getOldPersonTable () {
      let data = { orgid: this.orgid, page: this.currentPage, size: this.pageSize }
      queryoldpersonpage(data).then(res => {
        this.oldPersonList = res.data.oldpersons
        this.totalCells = res.data.cnt
      }).catch(() => {})
    },
    // 搜索
    getSearchTable1 () {
      if (this.$store.state.user.moduletag !== 2) {
        this.getSearchTable()
      } else {
        this.getHomebedElderlyData()
      }
    },
    getSearchTable () {
      this.currentPage = 1
      this.pageSize = 20
      let data = { lessname: this.searchKeyword, page: this.currentPage, size: this.pageSize }
      if (this.searchKeyword === '') {
        this.getOldPersonTable()
        return
      }
      searcholdperson(data).then(res => {
        this.oldPersonList = res.data.persons
        this.totalCells = res.data.cnt
      }).catch(() => {})
    },
    blurSearch () {
      if (this.searchKeyword === '') {
        if (this.$store.state.user.moduletag !== 2) {
          this.getOldPersonTable()
        }
      }
    },
    // 查询入院列表
    getHomebedElderlyData () {
      this.tableData = []
      let params = {
        page: this.currentPage,
        size: this.pageSize
      }
      let data = {
        eid: this.$store.state.user.LoginResp.entity_id,
        curent_state: [0, 1, 2],
        elderly_name: this.searchKeyword,
        room_name: '',
        bed_name: ''
      }
      queryhomebedelderly(params, data).then(res => {
        this.totalCells = res.data.cnt
        this.oldPersonList = res.data.homebedperson
      })
    },
    // 获取所在床位
    getBedDesc (row) {
      let result = ''
      if (row.build_name) {
        result = row.build_name + '/' + row.floor_name + '/' + row.room_name + '/' + row.bed_name
      }
      return result
    },
    // 获取性别描述
    getSexDesc (sex) {
      return this.util.getSex(sex)
    },
    getAgeDesc (birthDate) {
      let result = ''
      let age = this.util.getAgeByBirth(birthDate)
      if (age === '') {
        result = '--'
      } else {
        result = age + '岁'
      }
      return result
    },
    handleCurrentChange (val) {
      this.currentPage = val
      if (this.$store.state.user.moduletag === 2) {
        this.getHomebedElderlyData()
        return
      }
      if (this.searchKeyword === '') {
        this.getOldPersonTable()
      } else {
        this.getSearchTable()
      }
    },
    // 选择
    changeOldPerson (item) {
      console.log(908, item)
      this.selectOldPersonObj = item
      this.serviceObj.oldperson = item
      this.sendObj.name = item.name
      if (this.$store.state.user.moduletag !== 2) {
        this.$refs.oldperson.changePerson(this.serviceObj)
      }
      this.getDeviceByHome()
    },
    // mqtt选择
    changeOldPerson1 (item) {
      console.log(908, item)
      this.selectOldPersonObj = item
      this.serviceObj.oldperson = item
      this.getDeviceByHome()
    },
    // 查询设备
    getDeviceByHome () {
      this.homeDeviceTable = []
      this.watchesTable = []
      let data = {hids: ''}
      if (this.$store.state.user.moduletag !== 2) {
        data.hids = [this.selectOldPersonObj.homeid]
      } else {
        data.hids = [this.selectOldPersonObj.hid]
      }
      querybinddevicebyhome(data).then(res => {
        let arr = res.data.devices
        for (let i = 0; i < arr.length; i++) {
          if (arr[i].devicetype === 700 || arr[i].devicetype === 504 || arr[i].devicetype === 507) {
            this.homeDeviceTable.push(arr[i])
          } else if (arr[i].devicetype === 300 || arr[i].devicetype === 901 || arr[i].devicetype === 350) {
            this.watchesTable.push(arr[i])
          }
        }
      }).catch(() => {})
    },
    // 平台拨打设备
    callVideo (row) {
      // console.log('mqtt', this.sendObj, this.selectOldPersonObj)
      this.sendObj.deviceid = row.deviceid
      this.$confirm('此操作将呼叫【' + row.deviceid + '】设备, 是否继续?', '提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '呼 叫',
        cancelButtonText: '自动接听来电',
        type: 'warning'
      }).then(() => {
        this.callVideoSend(row, 0)
      }).catch(action => {
        console.log('mqtt', action)
        if (action === 'cancel') {
          this.callVideoSend(row, 20)
        } else {
          // this.callVideoSend(row, 20)
        }
      })
    },
    callVideoSend (row, val) {
      let data = {
        deviceid: row.deviceid,
        name: this.$store.state.user.personname,
        videotype: 'video',
        platform: 2, // 1、SRS 2、即构视频
        autoreceive: parseInt(val) // 自动接听标识,单位秒，0 为不自动接听，最大40秒
      }
      calldeicevideo(data).then(res => {
        this.$store.commit('set_is_mqtt', true)
        this.roomID = res.data.roomid
        this.zgObj.roomID = res.data.roomid
        this.sendObj.roomid = res.data.roomid
        this.sendObj.name = this.selectOldPersonObj.name
        this.isMyCall = true
        let that = this
        this.$confirm('正在呼叫，请等候。', '通话视频', {
          confirmButtonText: '挂 断',
          showCancelButton: false,
          showClose: false,
          closeOnClickModal: false,
          iconClass: 'el-icon-video-camera'
        }).then(() => { // 未接通 平台挂断
          that.noCallEnd()
        }).catch(() => {})
        let obj = {datatype: 'phoneVoice', isShow: true}
        this.golobleObject.mqttVideoCall(obj) // 开始响铃
        this.$refs.zgpage.getDataMsg(this.zgObj)
        // 40s后没有mqtt通知 视为 设备不在线或未接通 平台挂断即构视频
        this.isCallTimer = setTimeout(() => {
          if (this.isMyCall) {
            that.$msgbox.close()
            this.$message({
              message: '设备不在线或未接通。',
              type: 'warning',
              duration: 4000
            })
            let obj = {datatype: 'phoneVoice', isShow: false}
            that.golobleObject.mqttVideoCall(obj) // 关闭响铃
          }
        }, 40000)
      }).catch(() => {})
    },
    noCallEnd () {
      this.isMyCall = false
      let obj = {datatype: 'phoneVoice', isShow: false}
      this.golobleObject.mqttVideoCall(obj) // 关闭响铃
      this.$store.commit('set_is_mqtt', false)
      this.store2.dispatch('other/update_zg_info', '')
      clearTimeout(this.isCallTimer)
      this.sendZg(1)
    },
    zgEnd () {
      this.isMyCall = false
      this.sendZg(1)
    },
    // 接口结果
    sendZg (val) {
      console.log(5678, this.sendObj)
      this.sendObj.result = val + ''
      // result: 0 接听，1拒接，2对方忙, 3对方未接
      receivedeicevideo(this.sendObj).then(res => {
        if (val === 0) {
          let obj = {datatype: 'phoneVoice', isShow: false}
          this.golobleObject.mqttVideoCall(obj) // 关闭响铃
          let obj1 = {datatype: 'callLeft', isShow: false}
          this.golobleObject.mqttVideoCall(obj1) // 关闭弹窗
          this.zgObj.roomID = this.sendObj.roomid
          this.$refs.zgpage.getDataMsg(this.zgObj)
          this.$refs.zgpage.getStartToken()
        } else {
          this.sendObj = {
            deviceid: '',
            name: '',
            videotype: 'video',
            roomid: '',
            result: ''
          }
        }
      }).catch(() => {})
    },
    // mqtt通知
    mqttResultZg (obj) {
      if (obj.datatype === 'rtccalloutresult') { // 平台拨打设备 通知结果
        clearTimeout(this.isCallTimer)
        if (this.isMyCall) {
          this.$msgbox.close()
        }
        this.isMyCall = false
        let obj1 = {datatype: 'phoneVoice', isShow: false}
        this.golobleObject.mqttVideoCall(obj1) // 关闭响铃
        // console.log('mqtt', obj, this.roomID)
        if (obj.roomid === this.roomID) {
          // resulttype: 0 接听，1拒接，2对方忙, 3对方未接
          if (parseInt(obj.resulttype) === 1 || parseInt(obj.resulttype) === 2 || parseInt(obj.resulttype) === 3) {
            this.$message({
              message: '对方已挂断。',
              type: 'success',
              duration: 3000
            })
            let obj2 = {datatype: 'callLeft', isShow: false}
            this.golobleObject.mqttVideoCall(obj2) // 关闭左上角弹窗
            this.sendObj = {
              deviceid: '',
              name: '',
              videotype: 'video',
              roomid: '',
              result: ''
            }
            this.$refs.zgpage.logoutRoomButton() // 退出房间
          } else if (parseInt(obj.resulttype) === 0) { // 0 接通 创建即构视频
            this.sendObj.deviceid = obj.deviceid
            this.sendObj.name = obj.name
            this.sendObj.roomid = obj.roomid
            this.$refs.zgpage.getStartToken()
          }
        }
      } else if (obj.datatype === 'rtccalltime') { // 结束弹窗通话时长
        // this.$store.commit('set_is_mqtt', false)
        // this.store2.dispatch('other/update_zg_info', '')
        // this.roomID = ''
        // let aa = '时长： ' + obj.calltime + '秒。  分辨率： ' + obj.resolution + '。'
        // this.$message({
        //   dangerouslyUseHTMLString: true,
        //   message: '<strong>' + aa + '</strong>',
        //   duration: 4000
        // })
      } else if (obj.datatype === 'videoZg') { // 已经在视频页接听
        console.log(999, obj, this.store2.state.other.zgVideoObj)
        if (this.store2.state.other.zgVideoObj !== '') {
          this.roomID = this.store2.state.other.zgVideoObj.roomid
          this.sendObj.deviceid = this.$route.query.deviceid ? this.$route.query.deviceid : obj.deviceid
          this.sendObj.name = this.store2.state.other.zgVideoObj.name
          this.sendObj.roomid = this.store2.state.other.zgVideoObj.roomid
          console.log(12345, this.sendObj, this.store2.state.other.zgVideoObj.name)
        }
        this.getOldPersonOyDid(obj.deviceid)
      }
    }
  }
}
</script>

<style scoped>
.card-person{
  cursor: pointer;
  border-bottom: 1px solid #DCDFE6;
  margin-bottom: 10px;
}
.card-person:hover{
  background-color: #EBEEF5;
}
.top-name-person{
  height: 30px;
  line-height: 30px;
  color: #1a1a1a;
  font-size: 18px;
}
.bottom-phone-person{
  height: 20px;
  color: #999999;
  font-size: 14px;
}
.person-device{
  min-height: 300px;
  border: 1px solid #DCDFE6;
  margin: 0 15px;
  padding: 15px 0;
}
</style>



// WEBPACK FOOTER //
// src/components/systemlog/videoZg.vue